import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

import VueAwesomeSwiper from 'vue-awesome-swiper'
// 引入样式
// import 'swiper/css/swiper.css'
import 'swiper/swiper-bundle.css'

import axios from "axios"

Vue.use(ViewUI);
Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)
// 解析http
import { getUrl, getJsonUrl } from './util/help.js'
Vue.prototype.$getUrl = getUrl
Vue.prototype.$getJsonUrl = getJsonUrl
//解决跨域
Vue.prototype.HOST = "/"
// Vue.prototype.HOST = "http://192.168.2.15:28001/"
// Vue.prototype.HOST = "http://incons.com.cn/"
// 使用axios
Vue.prototype.$axios = axios

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
